const config = {
  endPointContact: process.env.URL_CONTACT || 'https://graphql.swiftask.ai/api/contact',
  endPointVerifyRecaptcha:  process.env.URL_VERIFY_RECAPTCHA ||'https://graphql.swiftask.ai/api/verifyRecaptcha' ,
  recaptchaSiteKey: process.env.RECAPCHATSITEKEY ||'',
  endPointGetPricing: process.env.URL_GET_PRICING ||'https://graphql.swiftask.ai/public/subplans',
};

export default config;

